import { render, staticRenderFns } from "./addBatchAreaModal.vue?vue&type=template&id=3715fa88&scoped=true"
import script from "./addBatchAreaModal.vue?vue&type=script&lang=js"
export * from "./addBatchAreaModal.vue?vue&type=script&lang=js"
import style0 from "./addBatchAreaModal.vue?vue&type=style&index=0&id=3715fa88&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3715fa88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3715fa88')) {
      api.createRecord('3715fa88', component.options)
    } else {
      api.reload('3715fa88', component.options)
    }
    module.hot.accept("./addBatchAreaModal.vue?vue&type=template&id=3715fa88&scoped=true", function () {
      api.rerender('3715fa88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectConfig/components/addBatchAreaModal.vue"
export default component.exports